export default __webpack_public_path__ + "static/media/insta.643ef296.svg";